export type DeleteQrCodeSettingsApiResponse = unknown;
export type DeleteQrCodeSettingsApiArg = {
  id: string;
};

export type CreateQrCodeSettingsRequestBody = {
  /** Branch identifier for branch-specific QR code settings */
  branchId: string;
  /** Enable QR code generation for bank transfer payments */
  bankTransfer: boolean;
  /** Enable QR code generation for cash payments */
  cash: boolean;
  /** Enable QR code generation for card payments */
  card: boolean;
  /** Enable QR code generation for offset payments */
  offset: boolean;
  /** Enable QR code generation for free of charge payments */
  freeOfCharge: boolean;
  /** Enable QR code generation for cash on delivery payments */
  cashOnDelivery: boolean;
};

export type UpdateQrCodeSettingsRequestBody = {
  /** Branch identifier for branch-specific QR code settings */
  branchId?: string | null;
  /** Enable QR code generation for bank transfer payments */
  bankTransfer: boolean;
  /** Enable QR code generation for cash payments */
  cash: boolean;
  /** Enable QR code generation for card payments */
  card: boolean;
  /** Enable QR code generation for offset payments */
  offset: boolean;
  /** Enable QR code generation for free of charge payments */
  freeOfCharge: boolean;
  /** Enable QR code generation for cash on delivery payments */
  cashOnDelivery: boolean;
};
export type QrCodeSettingsResponseBody = {
  id: string;
  branchId: string | null;
  bankTransfer: boolean;
  cash: boolean;
  card: boolean;
  offset: boolean;
  freeOfCharge: boolean;
  cashOnDelivery: boolean;
  isSystem: boolean;
};
export type CreateQrCodeSettingsApiResponse = /** status 201  */ QrCodeSettingsResponseBody;
export type CreateQrCodeSettingsApiArg = {
  createQrCodeSettingsRequestBody: CreateQrCodeSettingsRequestBody;
};
export type GetQrCodeSettingsApiResponse = /** status 200  */ QrCodeSettingsResponseBody;
export type GetQrCodeSettingsApiArg = {
  id: string;
};

export type UpdateQrCodeSettingsApiResponse = /** status 200  */ QrCodeSettingsResponseBody;
export type UpdateQrCodeSettingsApiArg = {
  id: string;

  updateQrCodeSettingsRequestBody: UpdateQrCodeSettingsRequestBody;
};
export type GetListQrCodeSettingsApiResponse = /** status 200  */ QrCodeSettingsResponseBody[];
export type GetListQrCodeSettingsApiArg = {};
